// extracted by mini-css-extract-plugin
export var layoutContainer = "_h-0";
export var layoutContainerNoRounding = "_h-6";
export var layoutContainerOpen = "_h-5";
export var layoutContainerResizing = "_h-1";
export var mainContent = "_h-2";
export var resizeDivider = "_h-3";
export var slidePanel = "_h-4";